import React from "react"
import Container from "../Container/Container"
import Header from "../Header/Header"
import Body from "../Body/Body"

/**
 * View for page
 * @component
 * return (
 *  <Product/>
 * )
 */
const Product = ({...props}) => {
  return (
    <Container>
      <Header />
      <Body />
    </Container>
  )
}

export default Product
